import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface BookNowButtonProps {
  text?: string;
  scrollThreshold?: number;
}

const BookNowButton: React.FC<BookNowButtonProps> = ({
  text = "Book Now",
  scrollThreshold = 300
}) => {
  const [visible, setVisible] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > scrollThreshold) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrollThreshold]);
  
  return (
    <div className={`fixed bottom-6 right-6 z-50 transition-all duration-300 transform ${
      visible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
    }`}>
      <Link
        to="/contact#booking"
        className="flex items-center gap-2 bg-amber-700 text-white px-5 py-3 rounded-full shadow-lg hover:bg-amber-800 hover:shadow-xl transition-all"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
        <span className="font-medium">{text}</span>
      </Link>
    </div>
  );
};

export default BookNowButton; 